import axios from "axios";

/** Fire-and-forget internal analytics event. */
export function trackEvent(event, meta = {}) {
  axios
    .post(`${process.env.REACT_APP_BACKEND_URL}/api/analytics/track`, {
      path: window.location.pathname,
      event,
      referrer: document.referrer || "",
      meta,
    })
    .catch(() => {});
}
